import baseGetAllKeys from "./_baseGetAllKeys.js";
import getSymbols from "./_getSymbols.js";
import keys from "./keys.js";
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}
export {
  getAllKeys as default
};
//# sourceMappingURL=_getAllKeys.js.map
